import { ConfigProvider } from 'antd';
import koKR from 'antd/locale/ko_KR';
import type { ReactNode } from 'react';

// antd 5.22 테마를 디자인 토큰(tokens.scss)과 1:1 매핑.
// SSOT 는 tokens.scss → 여기서는 hex 값을 mirroring.
// 정책 #7 (2026-08-07): 브랜드 primary 는 navi amber (#FFB53D).

const tokens = {
  colorPrimary: '#FFB53D',
  colorSuccess: '#10B981',
  colorWarning: '#F59E0B',
  colorError: '#EF4444',
  colorInfo: '#3B82F6',
  colorTextBase: '#0B1626',
  colorBgBase: '#EFF2F6',
  colorBgContainer: '#FFFFFF',
  borderRadius: 12,
  fontFamily:
    "'IBM Plex Sans KR','Pretendard','Apple SD Gothic Neo','Malgun Gothic',sans-serif",
};

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider
      locale={koKR}
      theme={{
        token: tokens,
        components: {
          Button: { controlHeight: 40, borderRadius: 10 },
          Input: { controlHeight: 40, borderRadius: 10 },
          Card: { borderRadiusLG: 14 },
          Menu: { itemHeight: 44 },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
